import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { closeBrowserSession } from '../actions';

export const useCloseBrowserApi = (consentGuid, logType) => {
  const dispatch = useDispatch();

  useEffect(() => {
    let sent = false;
    const handlePageHide = () => {
      if (sent) return;
      sent = true;

      // closeBrowserSession is a thunk creator; it only runs when dispatched
      Promise.resolve(dispatch(closeBrowserSession(consentGuid, logType))).catch(() => {});
    };

    window.addEventListener('beforeunload', handlePageHide);
    window.addEventListener('pagehide', handlePageHide);
    return () => {
      window.removeEventListener('beforeunload', handlePageHide);
      window.removeEventListener('pagehide', handlePageHide);
    };
  }, [dispatch, consentGuid, logType]);
};